import React from 'react'

import { Center, Heading, Stack, Text } from '@myxplor/stardust'

const NotFound = () => {
  return (
    <Center>
      <Stack align="center" space="xxsmall">
        <Heading level={2} weight="semiBold">
          404
        </Heading>
        <Heading>Page Not Found</Heading>
        <Text>Uh oh, we can&apos;t seem to find the page you were looking for.</Text>
      </Stack>
    </Center>
  )
}

export default NotFound
